import { styled, Box } from "@mui/material";
import { CheckCircle, Prohibit } from "@phosphor-icons/react";

import { PsDrawerDialog } from "stencilSetup";

export const PsDrawerDialogStyled = styled(PsDrawerDialog)(({ theme }) => ({
    '& .drawer-header h1': {
        fontWeight: '600',
    },
    '& .drawer-main':{
        paddingBottom: `${theme.spacing(25)} !important`,
    },
    'footer':{
        position: 'absolute !important',
    }
}));

export const CostPerPayPeriodBoxStyled = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

export const BenefitCategorieDetailsBoxStyled = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(3),
}));

export const BenefitCategoryTextStyled = styled('span')(({ theme }) => ({
    color: theme.palette.info.main
}));

export const CheckCircleStyled = styled(CheckCircle)(({ theme }) => ({
    color: theme.palette.success.main
}));

export const ProhibitStyled = styled(Prohibit)(({ theme }) => ({
    color: theme.palette.error.main
}));
